/* =====================================================
   ONLINEAND.DIRECT theme JS 1/3 (2026-10 redesign): consent wiring (kept verbatim), basket drawer,
   AJAX add to basket, menu drawer, header, back to top, recently viewed.
   2/3 is olad-product.js, 3/3 is olad-ui.js (split: the Admin API takes 16 KB per request).
   ===================================================== */

(function() {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function formatMoney(cents) { return '£' + (cents / 100).toFixed(2); }
  /* Same rule as snippets/olad-display-title.liquid, for JSON-sourced titles */
  function shortTitle(t) { return String(t || '').split(' | ')[0].replace(/^FW ?Style /, ''); }
  var ICON = {
    close: '<svg class="olad-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    check: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4.5 12.5 4.5 4.5 10.5-11"/></svg>',
    minus: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg class="olad-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
  };

  /* ── COOKIE CONSENT ── */
  /* This banner owns the UI and the localStorage flag, but the visitor's decision
     must ALSO reach Shopify's Customer Privacy API — that is what the Customer
     Events pixels actually read. Previously the decision was written to
     localStorage only, so Shopify saw no consent signal at all.
     Wiring this up is a prerequisite for switching off the native Shopify cookie
     banner (Settings > Customer privacy > Cookie banner), which is the element
     that lands ~3.7s late and becomes the LCP on a first visit. */
  function withCustomerPrivacy(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) { cb(window.Shopify.customerPrivacy); return; }
    if (!(window.Shopify && window.Shopify.loadFeatures)) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err) {
      if (err || !(window.Shopify && window.Shopify.customerPrivacy)) {
        console.warn('[olad-consent] Customer Privacy API unavailable', err);
        return;
      }
      cb(window.Shopify.customerPrivacy);
    });
  }

  function recordConsent(granted) {
    withCustomerPrivacy(function(cp) {
      cp.setTrackingConsent({
        analytics: granted,
        marketing: granted,
        preferences: granted,
        sale_of_data: granted
      }, function(res) {
        if (res && res.error) console.warn('[olad-consent] setTrackingConsent failed', res.error);
      });
    });
  }

  function initCookieBanner() {
    var banner = document.getElementById('olad-cookie-banner');
    if (!banner) return;
    var acceptBtn = document.getElementById('olad-cookie-accept');
    var declineBtn = document.getElementById('olad-cookie-decline');
    if (acceptBtn) acceptBtn.addEventListener('click', function() {
      localStorage.setItem('olad-cookies', 'accepted');
      banner.style.display = 'none';
      recordConsent(true);
    });
    if (declineBtn) declineBtn.addEventListener('click', function() {
      localStorage.setItem('olad-cookies', 'necessary');
      banner.style.display = 'none';
      recordConsent(false);
    });
    /* Footer "Cookie settings" reopens the banner so a visitor can change their mind */
    $all('[data-cookie-settings]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        banner.style.display = 'block';
        if (acceptBtn) acceptBtn.focus();
      });
    });
    var accepted = localStorage.getItem('olad-cookies');
    if (accepted) {
      banner.style.display = 'none';
      /* Visitors who answered the old localStorage-only banner hold a decision
         Shopify never recorded. Mirror it across once, but never overwrite an
         explicit consent the API already holds. */
      withCustomerPrivacy(function(cp) {
        var current = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
        if (current && (current.analytics === 'yes' || current.analytics === 'no')) return;
        recordConsent(accepted === 'accepted');
      });
      return;
    }
    banner.style.display = 'block';
  }

  /* ── CART DRAWER ── */
  function setCartCount(count) {
    $all('.olad-cart-count').forEach(function(el) { el.textContent = count; });
    $all('[data-open-cart]').forEach(function(el) { el.setAttribute('aria-label', 'Basket, ' + count + ' item' + (count === 1 ? '' : 's')); });
  }

  function initCartDrawer() {
    var drawer = document.getElementById('olad-cart-drawer');
    var overlay = document.getElementById('olad-cart-overlay');
    var closeBtn = document.getElementById('olad-cart-close');
    if (!drawer || !overlay) return;
    var lastFocus = null;

    function openCart() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      overlay.classList.add('is-visible');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }
    function closeCart() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart(); });
    $all('[data-open-cart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) { e.preventDefault(); openCart(); refreshCartDrawer(); });
    });

    document.addEventListener('click', function(e) {
      var btn = e.target.closest ? e.target.closest('.olad-qty-btn') : null;
      if (!btn) return;
      var key = btn.getAttribute('data-key');
      var action = btn.getAttribute('data-action');
      var itemEl = btn.closest('.olad-cart-drawer__item');
      var qtyEl = itemEl ? itemEl.querySelector('.olad-cart-drawer__item-qty span') : null;
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var newQty = action === 'decrease' ? Math.max(0, currentQty - 1) : currentQty + 1;
      updateCartItem(key, newQty);
    });

    window.openCartDrawer = openCart;
  }

  function refreshCartDrawer() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var itemsEl = document.getElementById('olad-cart-items');
        var drawerTotalEl = document.querySelector('.olad-cart-drawer__total span:last-child');
        if (drawerTotalEl) drawerTotalEl.textContent = formatMoney(cart.total_price);
        setCartCount(cart.item_count);
        if (!itemsEl) return;
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<p class="olad-cart-drawer__empty">Your basket is empty.</p>';
          return;
        }
        var html = '';
        cart.items.forEach(function(item) {
          html += '<div class="olad-cart-drawer__item" data-key="' + esc(item.key) + '">';
          if (item.image) html += '<img src="' + esc(item.image) + '" alt="" width="80" height="80" loading="lazy">';
          html += '<div class="olad-cart-drawer__item-info">';
          html += '<p class="olad-cart-drawer__item-title">' + esc(shortTitle(item.product_title)) + '</p>';
          if (item.variant_title && item.variant_title !== 'Default Title') {
            html += '<p class="olad-cart-drawer__item-variant">' + esc(item.variant_title) + '</p>';
          }
          html += '<p class="olad-cart-drawer__item-price">' + formatMoney(item.line_price) + '</p>';
          html += '<div class="olad-cart-drawer__item-qty">';
          html += '<button type="button" class="olad-qty-btn" data-action="decrease" data-key="' + esc(item.key) + '" aria-label="Decrease quantity">' + ICON.minus + '</button>';
          html += '<span>' + item.quantity + '</span>';
          html += '<button type="button" class="olad-qty-btn" data-action="increase" data-key="' + esc(item.key) + '" aria-label="Increase quantity">' + ICON.plus + '</button>';
          html += '</div></div></div>';
        });
        itemsEl.innerHTML = html;
      })
      .catch(function(err) { console.error('Cart refresh error:', err); });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() { refreshCartDrawer(); })
    .catch(function(err) { console.error('Cart update error:', err); });
  }

  /* ── AJAX ADD TO BASKET ── */
  function initAjaxCart() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) return;
      if (form.getAttribute('method') && form.getAttribute('method').toLowerCase() !== 'post') return;
      if (!form.querySelector('[name="id"]')) return;
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var label = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.textContent = 'Adding...'; submitBtn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json().then(function(j) { if (!r.ok) throw j; return j; }); })
        .then(function() {
          refreshCartDrawer();
          if (window.openCartDrawer) window.openCartDrawer();
          if (submitBtn) {
            submitBtn.textContent = 'Added to basket';
            setTimeout(function() { submitBtn.textContent = label; submitBtn.disabled = false; }, 2000);
          }
        })
        .catch(function(err) {
          console.error('Add to basket error:', err);
          if (submitBtn) { submitBtn.textContent = label; submitBtn.disabled = false; }
          if (err && err.description) alert(err.description);
        });
    });
  }

  /* ── MOBILE MENU DRAWER ── */
  function initMenuDrawer() {
    var drawer = document.getElementById('olad-menu-drawer');
    var overlay = document.getElementById('olad-menu-overlay');
    var openBtn = document.querySelector('[data-menu-open]');
    if (!drawer || !openBtn) return;
    var closeBtns = $all('[data-menu-close]');
    function open() {
      drawer.hidden = false; if (overlay) overlay.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button'); if (first) first.focus();
    }
    function close() {
      drawer.hidden = true; if (overlay) overlay.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    closeBtns.forEach(function(b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ── HEADER: mobile search toggle, help menu ── */
  function initHeader() {
    var mast = document.querySelector('.olad-masthead');
    var toggle = document.querySelector('[data-search-toggle]');
    if (mast && toggle) {
      toggle.addEventListener('click', function() {
        var open = mast.classList.toggle('is-search-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var i = document.getElementById('olad-q'); if (i) i.focus(); }
      });
    }
    var help = document.querySelector('.olad-help');
    if (help) {
      document.addEventListener('click', function(e) { if (help.open && !help.contains(e.target)) help.open = false; });
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && help.open) { help.open = false; help.querySelector('summary').focus(); } });
    }
  }

  /* ── BACK TO TOP ── */
  function initBackToTop() {
    var btn = document.getElementById('olad-back-top');
    if (!btn) return;
    window.addEventListener('scroll', function() { btn.style.display = window.scrollY > 600 ? 'flex' : 'none'; }, { passive: true });
    btn.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ── RECENTLY VIEWED ── */
  function trackRecentlyViewed() {
    if (typeof window.productHandle === 'undefined') return;
    try {
      var viewed = JSON.parse(localStorage.getItem('olad-recently-viewed') || '[]');
      var current = { handle: window.productHandle, title: window.productTitle, price: window.productPrice, image: window.productImage, url: window.productUrl };
      viewed = viewed.filter(function(p) { return p.handle !== current.handle; });
      viewed.unshift(current);
      viewed = viewed.slice(0, 6);
      localStorage.setItem('olad-recently-viewed', JSON.stringify(viewed));
    } catch (e) {}
  }

  function renderRecentlyViewed() {
    var container = document.getElementById('olad-recently-viewed');
    if (!container) return;
    var section = container.closest('section') || container.parentElement;
    try {
      var viewed = JSON.parse(localStorage.getItem('olad-recently-viewed') || '[]');
      var filtered = viewed.filter(function(p) { return p.handle !== window.productHandle; }).slice(0, 4);
      if (!filtered.length) { section.style.display = 'none'; return; }
      var html = '';
      filtered.forEach(function(p) {
        var t = shortTitle(p.title);
        html += '<article class="olad-card"><a class="olad-card__link" href="' + esc(p.url) + '">';
        html += '<div class="olad-card__media">' + (p.image ? '<img class="olad-card__img" src="' + esc(p.image) + '" alt="' + esc(t) + '" width="400" height="400" loading="lazy">' : '') + '</div>';
        html += '<h3 class="olad-card__title">' + esc(t) + '</h3>';
        html += '<div class="olad-card__foot">' + (p.price ? '<p class="olad-card__price"><strong>' + esc(p.price) + '</strong></p>' : '') + '<p class="olad-card__free">Free mainland delivery</p></div>';
        html += '</a></article>';
      });
      container.innerHTML = html;
    } catch (e) { section.style.display = 'none'; }
  }

  /* ── INIT ── */
  function init() {
    initCookieBanner();
    initCartDrawer();
    initAjaxCart();
    initHeader();
    initMenuDrawer();
    initBackToTop();
    trackRecentlyViewed();
    renderRecentlyViewed();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

})();